import { Type } from "@angular/core";
import {
  bundle,
  categories,
  companies,
  company,
  coupons,
  customers,
  operator,
  operators,
  plan,
  planDescriptions,
  products,
  promotions,
  resellers,
  resellerWarehouses,
  sales,
  salon,
  salons,
  services,
  subCategories,
  subscriptions,
  suggestedProducts,
  users,
  warehouse,
} from "./models/universal-json";
import { BookingComponent } from "./pages/booking/booking.component";
import { OperatorShiftsComponent } from "./pages/operator-shifts/operator-shifts.component";
import { UserComponent } from "./pages/user/user.component";
import { CashRegisterComponent } from "./pages/cash-register/cash-register.component";
import { CompleteProfileComponent } from "./pages/complete-profile/complete-profile.component";
import { ReminderComponent } from "./pages/reminder/reminder.component";
import { UserDashboardComponent } from "./pages/user-dashboard/user-dashboard.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { UniversalCrudComponent, UniversalDetailsComponent } from "@stdoutsrl/design-kit";

export const routingTranslated: RouteTranslatedInterface[] = [
  {
    component: UniversalCrudComponent,
    data: salons,
    paths: ["saloni", "salons"],
    titles: ["Saloni", "Salons"],
    breadcrumbIndex: 0,
  },
  {
    component: UniversalCrudComponent,
    data: resellerWarehouses,
    paths: ["magazzini", "warehouses"],
    titles: ["Magazzini", "Marehouses"],
    breadcrumbIndex: 0,
  },
  {
    paths: ["customers", "clienti"],
    titles: ["Customers", "Clienti"],
    component: UniversalCrudComponent,
    data: customers,
    breadcrumbIndex: 0,
  },
  {
    paths: ["promotions", "promozioni"],
    titles: ["Promotions", "Promozioni"],
    component: UniversalCrudComponent,
    data: promotions,
    breadcrumbIndex: 0,
  },
  {
    paths: ["coupons"],
    titles: ["Coupons"],
    component: UniversalCrudComponent,
    data: coupons,
    breadcrumbIndex: 0,
  },

  {
    paths: ["services", "servizi"],
    titles: ["Services", "Servizi"],
    component: UniversalCrudComponent,
    data: services,
    breadcrumbIndex: 0,
  },
  {
    paths: ["users", "utenti"],
    titles: ["Users", "Utenti"],
    component: UniversalCrudComponent,
    data: users,
    breadcrumbIndex: 0,
  },
  {
    paths: ["companies", "aziende"],
    titles: ["Companies", "Aziende"],
    component: UniversalCrudComponent,
    data: companies,
    breadcrumbIndex: 0,
  },
  {
    paths: ["company/:id", "azienda/:id"],
    titles: ["Company", "Azienda"],
    component: UniversalDetailsComponent,
    data: company,
    breadcrumbIndex: 1,
  },
  {
    paths: ["salon/:id", "salone/:id"],
    titles: ["Salon", "Salone"],
    component: UniversalDetailsComponent,
    data: salon,
    breadcrumbIndex: 1,
  },
  {
    paths: ["operator/:id", "operatore/:id"],
    titles: ["Operator", "Operatore"],
    component: UniversalDetailsComponent,
    data: operator,
    breadcrumbIndex: 1,
  },
  {
    paths: ["operator-shifts", "turni-operatori"],
    titles: ["Operator shifts", "Turni operatori"],
    component: OperatorShiftsComponent,
    data: operators,
    breadcrumbIndex: 0,
  },
  {
    paths: ["plans", "piani"],
    titles: ["Plans", "Piani"],
    component: UniversalCrudComponent,
    data: plan,
    breadcrumbIndex: 0,
  },
  {
    paths: ["categories", "categorie"],
    titles: ["Categories", "Categorie"],
    component: UniversalCrudComponent,
    data: categories,
    breadcrumbIndex: 0,
  },
  {
    paths: ["sub-categories", "sotto-categorie"],
    titles: ["Sub Categories", "Sotto Categorie"],
    component: UniversalCrudComponent,
    data: subCategories,
    breadcrumbIndex: 0,
  },
  {
    paths: ["warehouse", "magazzino"],
    titles: ["Warehouse", "Magazzino"],
    component: UniversalCrudComponent,
    data: warehouse,
    breadcrumbIndex: 0,
  },
  {
    paths: ["plan-descriptions", "descrizione-piani"],
    titles: ["Plan descriptions", "Descrizione piani"],
    component: UniversalCrudComponent,
    data: planDescriptions,
    breadcrumbIndex: 0,
  },
  {
    paths: ["history", "storico"],
    titles: ["History", "Storico"],
    component: UniversalCrudComponent,
    data: sales,
    breadcrumbIndex: 0,
  },
  {
    paths: ["products", "prodotti"],
    titles: ["Products", "Prodotti"],
    component: UniversalCrudComponent,
    data: products,
    breadcrumbIndex: 0,
  },
  {
    paths: ["subscriptions", "sottoscrizioni"],
    titles: ["Subscriptions", "Sottoscrizioni"],
    component: UniversalCrudComponent,
    data: subscriptions,
    breadcrumbIndex: 0,
  },
  {
    paths: ["resellers", "rivenditori"],
    titles: ["Resellers", "Rivenditori"],
    component: UniversalCrudComponent,
    data: resellers,
    breadcrumbIndex: 0,
  },
  {
    paths: ["bundles", "pacchetti"],
    titles: ["Bundles", "Pacchetti"],
    component: UniversalCrudComponent,
    data: bundle,
    breadcrumbIndex: 0,
  },
  {
    paths: ["bookings", "prenotazioni"],
    titles: ["Bookings", "Prenotazioni"],
    component: BookingComponent,
    data: {
      breadcrumb: [
        {
          title: "bookings",
          route: "/prenotazioni",
        },
      ],
    },
    breadcrumbIndex: 0,
  },
  {
    paths: ["profile", "profilo"],
    titles: ["Profile", "Profilo"],
    component: UserComponent,
    data: {
      breadcrumb: [
        {
          title: "Profilo utente",
          route: "/profilo",
        },
      ],
    },
    breadcrumbIndex: 0,
  },
  {
    paths: ["bookings", "prenotazioni"],
    titles: ["Bookings", "Prenotazioni"],
    component: BookingComponent,
    data: {
      breadcrumb: [
        {
          title: "Prenotazioni",
          route: "/prenotazioni",
        },
      ],
    },
    breadcrumbIndex: 0,
  },

  {
    paths: ["digital-cash-register", "cassa-digitale"],
    titles: ["Digital cash register", "Cassa digitale"],
    component: CashRegisterComponent,
    data: {
      breadcrumb: [
        {
          title: "Cassa digitale",
          route: "/cassa-digitale",
        },
      ],
    },
    breadcrumbIndex: 0,
  },
  {
    paths: ["complete-profile", "completa-profilo"],
    titles: ["Complete profile", "Completa profilo"],
    component: CompleteProfileComponent,
    data: {
      breadcrumb: [
        {
          title: "Completa profilo",
          route: "/completa-profilo",
        },
      ],
    },
    breadcrumbIndex: 0,
  },
  {
    paths: ["reminder", "promemoria"],
    titles: ["Reminder", "Promemoria"],
    component: ReminderComponent,
    data: {
      breadcrumb: [
        {
          title: "Promemoria",
          route: "/promemoria",
        },
      ],
    },
    breadcrumbIndex: 0,
  },

  {
    paths: ["user-dashboard", "dashboard-utente"],
    titles: ["User dashboard", "Dashboard utente"],
    component: UserDashboardComponent,
    data: {
      breadcrumb: [
        {
          title: "Dashboard",
          route: "/dashboard-utente",
        },
      ],
    },
    breadcrumbIndex: 0,
  },

  {
    paths: ["dashboard"],
    titles: ["Dashboard"],
    component: DashboardComponent,
    data: {
      breadcrumb: [
        {
          title: "dashboard",
          route: "/dashboard",
        },
      ],
    },
    breadcrumbIndex: 0,
  },
  {
    paths: ["reseller-dashboard", "dashboard-rivenditore"],
    titles: ["Reseller dashboard", "Dashboard rivenditore"],
    component: DashboardComponent,
    data: {
      breadcrumb: [
        {
          title: "Dashboard Reseller",
          route: "/reseller-dashboard",
        },
      ],
    },
    breadcrumbIndex: 0,
  },
  {
    paths: ["prodotti-suggeriti", "suggested-products"],
    titles: ["Prodotti suggeriti", "Suggested products"],
    component: UniversalCrudComponent,
    data: suggestedProducts,
    breadcrumbIndex: 0,
  },
];

export interface RouteTranslatedInterface {
  component: Type<any>;
  data?: any;
  paths: string[];
  titles: string[];
  breadcrumbIndex: number;
}
